<!--投标报价-->
<template>
  <div class="tender-container">
    <header-index/>
    <div class="tender-content">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{path: '/outsourceDemand/index' }">交易大厅</el-breadcrumb-item>
        <el-breadcrumb-item><a @click="back">招标详情</a></el-breadcrumb-item>
        <el-breadcrumb-item>投标报价</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="tender-offer">
        <el-form :model="tenderForm" :rules="tenderRule" ref="tenderForm" class="tenderForm" label-position="top">
          <el-form-item label="报价金额" prop="price">
            <el-input v-model="tenderForm.price" placeholder="请输入金额">
              <i slot="suffix" class="append-suffix">元</i>
            </el-input>
          </el-form-item>
          <el-form-item label="预计工期" prop="duration">
            <el-input v-model.number="tenderForm.duration" placeholder="请输入天数">
              <i slot="suffix" class="append-suffix">天</i>
            </el-input>
          </el-form-item>
          <el-form-item label="方案说明" prop="content">
            <el-input v-model="tenderForm.content" type="textarea" placeholder="请描述您的解决方案，增加您的竞争优势(400字内）"
                      :autosize="{ minRows: 7}" maxlength="400" show-word-limit/>
            <el-upload class="upload-demo" ref="upload" :file-list="fileList" drag :on-exceed="handleExceed"
                       :on-success="successUpload" accept=".png,.gif,.jpeg,.jpg"
                       :on-remove="handleRemove" multiple :limit="5"
                       action="http://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg">
              <i class="el-icon-upload"/>
              <div class="el-upload__text">
                <p style="margin-block-end: 0px;margin-block-start: 0px;">将文件拖到此处，或点击上传</p>
                <p style="margin-block-end: 0px;margin-block-start: 0px;font-size: 12px;">最多添加5个文件</p>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="tenderForm.phone" placeholder="请输入手机号码，便于雇主联系您"/>
          </el-form-item><br/><br/><br/><br/>
          <el-form-item>
            <span>报价金额：</span>
            <span class="red-span">{{tenderForm.price != null && tenderForm.price != '' ? '￥'+parseFloat(tenderForm.price).toFixed(2) : '￥0.00' }}</span>
            <el-button type="danger" @click="submitTender">提交报价</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <home_footer/>
    <Hang/>
    <el-dialog title="提示" :visible.sync="dialogVisible2" width="20%" class="dialog" center :close-on-click-modal="false">
      <p><i class="el-icon-success"/></p>
      <p>恭喜您报价成功！ 请耐心等待雇主选标</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger">继续投标</el-button>
        <el-button @click="dialogVisible2=false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import {isMobile} from '@/common/tools'
import {biddingQuote} from '@/api/cloudServiceApi'
export default {
  name: "tenderOffer",
  components: {headerIndex, home_footer, Hang},
  data() {
    const validateMoney = (rule, value, callback) => {
      if (!value) {
        callback(new Error('报价金额不能为空'))
      } else if (value.indexOf(".") != -1 && value.split('.').length > 2) {
        callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
      } else if (value.indexOf(".") != -1 && value.split('.')[1].length > 2) {
        callback(new Error('请输入正确的小数位数')) //小数点后两位
      } else {
        callback();
      }
    }
    const checkPhone = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入手机号码'));
      } else if (!isMobile(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    }
    return {
      tenderForm: {
        price: null,
        duration: null,
        content: '',
        fileList: [],
        phone: '',
      },
      dialogImageUrl: '',
      dialogVisible: false,
      dialogVisible2:false,
      fileList: [],
      tenderRule: {
        price: [
          {type: 'string', required: true, trigger: 'blur', validator: validateMoney},
        ],
        duration: [
          {required: true, message: '预计工期不能为空'},
          {type: 'number', message: '预计工期必须为数字值'},
        ],
        content: [
          {required: true, message: '请描述您的解决方案，增加您的竞争优势', trigger: 'blur'},
          {min: 5, max: 600, message: '长度在 5 到 400 个字符', trigger: 'blur'}
        ],
        phone: [
          {required: true, validator: checkPhone, trigger: 'blur'}
        ],
      },
      cid: 0,
      zid: 0
    }
  },
  methods: {
    /*返回上一级页面*/
    back() {
      this.$router.back(-1);
    },
    /*限制图片上传上限 超过提示*/
    handleExceed(files, fileList) {
      this.$message.error(`已超过上传上限！`);
    },
    /*图片上传成功后处理*/
    successUpload(response, file, fileList) {
      this.tenderForm.fileList = [];
      for (let list of fileList) {
        this.tenderForm.fileList.push({name: list.name, url: list.response.imgPath});
      }
    },
    /*删除图片*/
    handleRemove(file, fileList) {
      for (let i in this.tenderForm.fileList) {
        if (this.tenderForm.fileList[i].url == file.response.imgPath) {
          this.tenderForm.fileList.splice(i, 1)
          this.$message.success('删除成功！');
        }
      }
    },
    /*提交报价*/
    submitTender(){
      this.$refs.tenderForm.validate((valid) => {
        if (valid) {
          biddingQuote({
            appendix: this.tenderForm.fileList,
            content: this.tenderForm.content,
            duration: this.tenderForm.duration,
            mobile: this.tenderForm.phone,
            money: this.tenderForm.price,
            uid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
            zid: this.id
          }).then(res=>{
            if (res.code==200){
              this.$router.push({path: '/outsourceDemand/index'})
            }
          })
        } else {
          return false;
        }
      })
    }
  },
  beforeMount() {
    this.zid = this.$route.query.zid;
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
  }
}
</script>

<style scoped>
.tender-container >>> .tender-content .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-weight: bold;
  color: #5D5D5D;
}
.tender-container >>> .tender-content .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.tender-container >>> .tender-content .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.tender-container >>> .tender-content .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.tender-container >>> .tender-content .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #5D5D5D;
  font-family: 'SourceHanSansCN';
}
.tender-container >>> .tender-content .tender-offer .el-form--label-top .el-form-item__label {
  padding: 0 0 0px;
  font-weight: 100;
  font-size: 14px;
  font-family: 'SourceHanSansCN';
}
.tender-container >>> .tender-content .tender-offer .tenderForm .el-upload-dragger {
  background-color: #F7F7F7;
  border: 1px solid #EDEDED;
  border-radius: 0px;
  box-sizing: border-box;
  width: 100%;
  height: 100px;
  cursor: pointer;
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
}
.tender-container >>> .tender-content .tender-offer .tenderForm .el-upload {
  width: 100%;
}
.tender-container >>> .tender-content .tender-offer .tenderForm .el-upload-dragger .el-icon-upload {
  font-size: 26px;
  color: #ABABAB;
  margin: 0px 10px 0px 0px;
  line-height: normal;
  padding-bottom: 26px;
}
.tender-container >>> .tender-content .tender-offer .tenderForm .el-upload-dragger .el-upload__text {
  color: #ABABAB;
  line-height: 25px;
}
.tender-container >>> .tender-content .tender-offer .tenderForm .el-upload-list__item {
  font-size: 14px;
  color: #606266;
  width: fit-content;
}
.tender-container >>> .tender-content .tender-offer .tenderForm input::-webkit-input-placeholder,
.tender-container >>> .tender-content .tender-offer .tenderForm textarea::-webkit-input-placeholder {
  font-size: 14px;
  color: #ABABAB;
  font-family: 'SourceHanSansCN';
  font-weight: 100;
}
.tender-container >>> .tender-content .tender-offer .tenderForm .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  font-size: 14px;
  border-radius: 4px;
}
.tender-container >>> .dialog p{
  text-align: center;
  color: #333333;
  font-size: 14px;
}
.tender-container >>> .dialog .el-dialog__header {
  border-bottom: 1px solid #F7F7F7;
  padding: 15px 20px;
  background: #F7F7F7;
  vertical-align: middle;
  text-align: left;
}
.tender-container >>> .dialog .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  font-size: 14px;
  border-radius: 4px;
  padding-right: 25px;
  padding-left: 25px;
}
.tender-container >>> .dialog .el-icon-success{
  font-size: 45px;
  color: #3FCD9D;
}
.tender-container >>> .dialog .el-dialog--center .el-dialog__body {
  padding: 0px 25px 20px;
}
</style>
<style scoped lang="scss">
.tender-container {
  background: #F5F5F5;
  .tender-content {
    padding: 20px 18%;
    .tender-offer {
      background: #ffffff;
      padding: 30px;
      margin-top: 20px;
      .tenderForm {
        width: 70%;
        .append-suffix {
          font-style: normal;
          color: #666666;
          padding: 10px 15px;
        }
        .red-span {
          color: #FE273B;
          padding-right: 60px;
        }
      }
    }
  }
}
</style>